export const ISSUES_DASHBOARD_PATH = '/issues'
export const ISSUES_DASHBOARD_SEARCH_PATH = '/issues/search'
